import { Controller } from '@hotwired/stimulus';

// "Run a test in your own AI" on /benchmark: pick a task, copy its frozen prompt, paste the answer back.
export default class extends Controller {
  static targets = ['taskButton', 'title', 'prompt', 'copyButton', 'model', 'otherField', 'status', 'submitButton'];
  static values = { url: String };

  connect() {
    const first = this.taskButtonTargets[0];
    if (first) this.select(first);
  }

  pick(event) {
    this.select(event.currentTarget);
  }

  select(button) {
    this.taskButtonTargets.forEach((b) => b.setAttribute('aria-pressed', String(b === button)));
    this.slug = button.dataset.benchmarkSubmitSlugParam;
    this.titleTarget.textContent = button.dataset.benchmarkSubmitTitleParam;
    this.promptTarget.textContent = button.dataset.benchmarkSubmitPromptParam;
    this.statusTarget.textContent = '';
  }

  async copy() {
    try {
      await navigator.clipboard.writeText(this.promptTarget.textContent);
      this.copyButtonTarget.textContent = 'Copied ✓';
    } catch {
      this.copyButtonTarget.textContent = 'Select the text and copy it';
    }
    setTimeout(() => { this.copyButtonTarget.textContent = 'Copy prompt'; }, 2000);
  }

  modelChanged() {
    const other = this.modelTarget.value === 'other';
    this.otherFieldTarget.classList.toggle('hidden', !other);
    this.otherFieldTarget.classList.toggle('block', other);
    this.otherFieldTarget.querySelector('input').required = other;
  }

  async submit(event) {
    event.preventDefault();
    const form = event.currentTarget;
    const body = new URLSearchParams(new FormData(form));
    body.set('task', this.slug);
    this.submitButtonTarget.disabled = true;
    try {
      const res = await fetch(this.urlValue, { method: 'POST', body, credentials: 'same-origin' });
      const json = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(json.error || 'Something went wrong. Try again.');
      form.reset();
      this.modelChanged();
      this.statusTarget.className = 'text-sm text-[#188038]';
      this.statusTarget.textContent = 'Thanks! Your result is in. It counts once it\'s checked, usually within a day.';
    } catch (error) {
      this.statusTarget.className = 'text-sm text-red-700';
      this.statusTarget.textContent = error.message;
    } finally {
      this.submitButtonTarget.disabled = false;
    }
  }
}
